export class PowerReviewHandlerCssService {
  static ION_COLOR_DARK = 'var(--ion-color-dark)';
  static ION_COLOR_GREEN = 'var(--ion-color-primary-green)';
  static ION_COLOR_PRIMARY_GREEN_20 = 'var(--ion-color-primary-green-20)';
  static ION_COLOR_GRAY_20 = 'var(--ion-color-gray-20)';
  static IMPORTANT = 'important';
  static isRender = false;

  static override() {
    if (!this.isRender) {
      this.demographicBreakDown();
      setTimeout(this.overrideDropdown, 1000);
      this.isRender = true;
    }
  }

  static overrideDropdown() {
    const selects: NodeListOf<HTMLSelectElement> = document.querySelectorAll(
      '.pr-rd-sort-group select, .pr-qa-sort-group select',
    );
    if (!selects) return;

    selects.forEach(select => {
      const options: HTMLOptionsCollection = select.options;
      const parent: HTMLElement = select.parentElement;
      if (!!parent.querySelector('label')) {
        parent.removeChild(parent.querySelector('label'));
      }
      const text = document.createElement('span');
      text.innerText = 'Sort by: ';
      text.className = 'sort-by';
      parent.insertBefore(text, select);
      const size = options.length;
      for (var i = 0; i < size; i++) {
        const option = document.createElement('option');
        option.text = options.item(i).text;
        option.value = options.item(i).value;
        select.appendChild(option);
      }
      select.removeChild(
        document.querySelector('.' + parent.className + ' optgroup'),
      );
    });
  }

  static demographicBreakDown() {
    const liItemClass = document.getElementsByClassName(
      'pr-ratings-histogram-list-item',
    );
    const labelClass = document.getElementsByClassName('pr-histogram-label');
    const countClass = document.getElementsByClassName('pr-histogram-count');
    const barClass = document.getElementsByClassName(
      'pr-ratings-histogram-bar',
    );

    this.calculateCountPercentage(countClass);

    if (liItemClass) {
      for (let i = 0; i < liItemClass.length; i++) {
        let element = liItemClass[i] as HTMLElement;
        element.id = i.toString();

        element.addEventListener('click', event => {
          // Update all the elements to first state except the current selected element
          for (let c = 0; c < liItemClass.length; c++) {
            if (element.id !== liItemClass[c].id) {
              (labelClass[c] as HTMLElement).style.setProperty(
                'color',
                this.ION_COLOR_DARK,
                this.IMPORTANT,
              );
              (countClass[c] as HTMLElement).style.setProperty(
                'color',
                this.ION_COLOR_DARK,
                this.IMPORTANT,
              );

              (labelClass[
                c
              ] as HTMLElement).style.cssText = `p:hover{ color: ${this.ION_COLOR_GREEN} }`;
              (countClass[
                c
              ] as HTMLElement).style.cssText = `p:hover{ color: ${this.ION_COLOR_GREEN} }`;

              (barClass[c] as HTMLElement).style.setProperty(
                'background-color',
                '#fafafa',
                this.IMPORTANT,
              );
              (barClass[
                c
              ] as HTMLElement).style.cssText = `div:hover{ background-color: ${this.ION_COLOR_GRAY_20} }`;
            }
          }

          // lABEL
          const labelElement = element.querySelector(
            '.pr-histogram-label',
          ) as HTMLElement;
          if (labelElement.style.color === this.ION_COLOR_GREEN) {
            labelElement.style.setProperty(
              'color',
              this.ION_COLOR_DARK,
              this.IMPORTANT,
            );
            labelElement.style.cssText = `p:hover{ color: ${this.ION_COLOR_GREEN} }`;
          } else {
            labelElement.style.setProperty(
              'color',
              this.ION_COLOR_GREEN,
              this.IMPORTANT,
            );
          }
          // COUNT
          const countElement = element.querySelector(
            '.pr-histogram-count',
          ) as HTMLElement;
          if (countElement.style.color === this.ION_COLOR_GREEN) {
            countElement.style.setProperty(
              'color',
              this.ION_COLOR_DARK,
              this.IMPORTANT,
            );
            countElement.style.cssText = `p:hover{ color: ${this.ION_COLOR_GREEN} }`;
          } else {
            countElement.style.setProperty(
              'color',
              this.ION_COLOR_GREEN,
              this.IMPORTANT,
            );
          }
          // BAR
          const barElement = element.querySelector(
            '.pr-ratings-histogram-bar',
          ) as HTMLElement;
          if (
            barElement.style.backgroundColor === this.ION_COLOR_PRIMARY_GREEN_20
          ) {
            barElement.style.setProperty(
              'background-color',
              '#fafafa',
              this.IMPORTANT,
            );
          } else {
            barElement.style.setProperty(
              'background-color',
              this.ION_COLOR_PRIMARY_GREEN_20,
              this.IMPORTANT,
            );
          }
        });
      }
    }
  }

  static calculateCountPercentage(countClass) {
    let countSum = 0;
    for (let i = 0; i < countClass.length; i++) {
      countSum += parseInt(countClass[i].textContent);
    }
    for (let i = 0; i < countClass.length; i++) {
      const calculated = Math.floor(
        (parseInt(countClass[i].textContent) / countSum) * 100,
      );
      countClass[i].innerHTML = calculated.toString() + '%';
    }
  }
}
